// Google Tag Manager dataLayer altyapısı.
// GTM container (GTM-MM3R2JZ2) public/index.html içinde statik yüklenir;
// burada yalnızca dönüşüm eventleri dataLayer'a push edilir.
// Trigger/tag yapılandırması GTM panelinden yapılır.

const RECENT_EVENT_WINDOW_MS = 500;
let lastEventKey = "";
let lastEventAt = 0;

export const trackEvent = (event, buttonLocation) => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];

  // Aynı tıklamanın (bubbling / çift handler) iki kez sayılmasını engeller;
  // gerçek, ayrı zamanlı tıklamaları engellemez.
  const key = `${event}:${buttonLocation}`;
  const now = Date.now();
  if (key === lastEventKey && now - lastEventAt < RECENT_EVENT_WINDOW_MS) return;
  lastEventKey = key;
  lastEventAt = now;

  window.dataLayer.push({
    event,
    button_location: buttonLocation,
    page_path: window.location.pathname,
    page_title: document.title,
  });
};
